import { inject, ModuleWithProviders, NgModule, provideAppInitializer } from '@angular/core';
import { IdleActivityConfigInjectionToken } from './idle-activity-config-injection.token';
import { IdleStateChangeHandler } from './idle-state-change.handler';
import { IdleActivityService } from './idle-activity.service';
import { IdleActivityConfig } from './idle-activity-config';
import { IdleUtils } from './idle-utils';
import { NgIdleModule } from '@ng-idle/core';

export function monitorIdleActivity(
  idleActivityService: IdleActivityService,
  idleStateChangeHandler: IdleStateChangeHandler,
  idleUtils: IdleUtils
): () => Promise<void> {
  return () =>
    new Promise((resolve) => {
      idleUtils.trace('monitorIdleActivity fn: setup', idleActivityService, idleStateChangeHandler);
      idleActivityService.initialise();
      idleStateChangeHandler.configureIdleMonitoring();
      resolve();
    });
}

// @dynamic
@NgModule({
  imports: [NgIdleModule.forRoot()]
})
export class IdleActivityModule {
  static forRoot(config: IdleActivityConfig): ModuleWithProviders<IdleActivityModule> {
    return {
      ngModule: IdleActivityModule,
      providers: [
        {
          provide: IdleActivityConfigInjectionToken,
          useValue: config
        },
        provideAppInitializer(() => {
          return monitorIdleActivity(inject(IdleActivityService), inject(IdleStateChangeHandler), inject(IdleUtils))();
        })
      ]
    };
  }
}
